module.exports = __webpack_public_path__ + "videos/brushes_cn.a764628.mp4";